import { PAGE_ONE } from "ui/pagination";
import { IPaginationParams } from "ui/pagination/types";
import { ITabsData } from "ui/tabs/types";

import FlexSavings from "./content/flex";
import GoalSavings from "./content/goal";
import VaultSavings from "./content/vault";
import { IIndividualTypeColor } from "./types";

export const PAGE_LIMIT = 10;
export const FIRST_INDEX = 0;
export const SECOND_INDEX = 1;
export const THIRD_INDEX = 2;
export const MIN_REASON_LENGTH = 5;

export enum IndividualSavingsSubRouteName {
  FLEX = "Flex Savings",
  GOAL = "Goal Savings",
  VAULT = "Vault Savings",
}

export enum IndividualSavingsTabStatus {
  FLEX = "flex",
  GOAL = "goal",
  VAULT = "vault",
}

export const SAVINGS_TRANSACTIONS_PAGE_LIMIT = 10;

export const DEFAULT_SAVINGS_TRANSACTIONS_PAGINATION_PARAMS: IPaginationParams =
  {
    limit: PAGE_LIMIT || SAVINGS_TRANSACTIONS_PAGE_LIMIT,
    page: PAGE_ONE,
  };

export const ALL_INDIVIDUALS_SAVINGS_TRANSACTION_TYPE = [
  "all",
  "credit",
  "debit",
];
export const ALL_INDIVIDUALS_SAVINGS_TRANSACTION_TYPE_LIST = [
  "all",
  "savings",
  "interest",
  "withdrawals",
];
export const ALL_INDIVIDUALS_SAVINGS_TRANSACTION_STATUS_LIST = [
  "all",
  "successful",
  "pending",
  "failed",
  "reversed",
];
export const ALL_INDIVIDUALS_SAVINGS_WORKER_TYPE_LIST = [
  "all",
  "employer",
  "employee",
];

export const ALL_INDIVIDUALS_SAVINGS_SOURCE_LIST = ["all", "wallet", "card"];
export const ALL_INDIVIDUALS_SAVINGS_FREQUENCY_LIST = [
  "all",
  "daily",
  "weekly",
  "monthly",
];
export const ALL_INDIVIDUALS_SAVINGS_STATUS_LIST = [
  "all",
  "active",
  "completed",
  "paused",
  "stopped",
];

export const INDIVIDUAL_SAVINGS_TAB_CONTENT_LIST: ITabsData[] = [
  {
    value: IndividualSavingsTabStatus.FLEX,
    content: <FlexSavings />,
  },
  {
    value: IndividualSavingsTabStatus.GOAL,
    content: <GoalSavings />,
  },
  {
    value: IndividualSavingsTabStatus.VAULT,
    content: <VaultSavings />,
  },
];

export const flexSavingsColumns = [
  "Saver's Name",
  "Amount Saved",
  "Interest Earned",
  "Start Date",
  "Source",
  "Zero Interest",
  "Frequency",
  "",
];

export const goalSavingsColumns = [
  "Saver's Name",
  "Goal Name",
  "Goal Amount",
  "Amount Saved",
  "Interest Earned",
  "Maturity Date",
  "Source",
  "Status",
  "",
];

export const vaultSavingsColumns = [
  "Saver's Name",
  "Vault Name",
  "Amount Saved",
  "Interest Earned",
  "Maturity Date",
  "Duration",
  "Status",
  "",
];

export const savingsHistoryColumns = [
  "Transaction",
  "Amount",
  "Date And Time",
  "",
];

export const flexSavingsHistoryColumns = [
  "Transaction",
  "Amount",
  "Funding Source",
  "Date And Time",
  "",
];

export const goalSavingsHistoryColumns = [
  "Transaction",
  "Amount",
  "Funding Source",
  "Date And Time",
  "",
];

export const vaultSavingsHistoryColumns = [
  "Transaction",
  "Amount",
  "Funding Source",
  "Date And Time",
  "",
];

export const INDIVIDUALS_LIST_TABLE_PAGE_LIMIT = 10;
export const INDIVIDUALS_LIST_TABLE_PAGINATION_PARAMS: IPaginationParams = {
  page: PAGE_ONE,
  limit: INDIVIDUALS_LIST_TABLE_PAGE_LIMIT,
};

export const IndividualTypeColorMap: Record<string, IIndividualTypeColor> = {
  0: {
    color: "#344054",
    bg: "#F2F4F7",
  },
  1: {
    color: "#344054",
    bg: "#F2F4F7",
  },
  3: {
    color: "#175CD3",
    bg: "#EFF8FF",
  },
};

export const COLORS: string[] = [
  "#163FA5", // Deep Blue
  "#4A148C", // Deep Purple
  "#D84315", // Deep Orange
  "#C62828", // Deep Red
  "#2E7D32", // Deep Green
  "#283593", // Indigo
  "#6A1B9A", // Violet
  "#1565C0", // Royal Blue
  "#8E24AA", // Amethyst
  "#FF6F00", // Deep Amber
];

export const savingsHistoryColumnsData = [
  "Transaction",
  "Amount",
  "Reference",
  "Date And Time",
  "",
];
